import React from 'react';

interface IcoSortProps {
    rotate?: boolean;
    size?: number;
}

export const IcoSort: React.FC<IcoSortProps> = ({ rotate = false, size = 8 }) => {
    const rotation = rotate ? 'rotate(180)' : 'rotate(0)';
    const transition = 'transform 0.1s ease-in-out';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} style={{ transform: rotation, transition: transition }}>
            <path
                fill="#B8B8B8"
                d="M1.224 2.24c-.518 0-.779.648-.414 1.03l2.591 2.71A.826.826 0 0 0 4 6.24v-4H1.224zm3.375 3.741L7.19 3.27c.365-.382.104-1.03-.414-1.03H4v4a.826.826 0 0 0 .599-.259z"
                opacity=".6"
            />
        </svg>
    );
};
